import React from 'react';

import { DOCUMENT_TYPES } from '~constants/common';

import { useToast } from '~libs/toast';

import { AsyncActionIcon } from '~components';
import { faEnvelope, faFilePdf } from '~components/icon';
import { Row } from '~components/table-view-v3';
import { useDocumentBatchGeneration } from '~main/components/document-batch-jobs/useDocumentBatchGeneration';

interface ComponentProps {
  row?: Row;
}

const CoContributionExportActions: React.FC<ComponentProps> = ({ row }) => {
  const { generateSeparate, emailSeparate, isGenerating } = useDocumentBatchGeneration();
  const { showToast } = useToast();

  const handleGeneratePdf = async () => {
    if (!row?.id) return;
    try {
      await generateSeparate(DOCUMENT_TYPES.CO_CONTRIBUTION.SINGLE, [row.id as string]).unwrap();
      showToast('success', 'Invoice PDF generation started');
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to start invoice generation';
      showToast('danger', message);
      console.error('Invoice PDF generation failed:', error);
      throw error;
    }
  };

  const handleEmailPdf = async () => {
    if (!row?.id) return;
    try {
      await emailSeparate(DOCUMENT_TYPES.CO_CONTRIBUTION.SINGLE, [row.id as string]).unwrap();
      showToast('success', 'Invoice email scheduled');
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to schedule invoice email';
      showToast('danger', message);
      console.error('Invoice email scheduling failed:', error);
      throw error;
    }
  };

  return (
    <div className="d-flex align-items-center">
      <AsyncActionIcon
        id="generate-invoice-pdf-icon"
        icon={faFilePdf}
        toolTip="Generate PDF"
        onClick={handleGeneratePdf}
        disabled={isGenerating || !row?.id}
        successTitle="Invoice generation started"
        spinnerDataCy="invoice-generate-spinner"
      />
      <AsyncActionIcon
        id="email-invoice-icon"
        icon={faEnvelope}
        toolTip="Email Invoice"
        onClick={handleEmailPdf}
        disabled={isGenerating || !row?.id}
        successTitle="Invoice email scheduled"
        spinnerDataCy="invoice-email-spinner"
      />
    </div>
  );
};

export default CoContributionExportActions;
